(function (UX) {
    /**
     * UX Namespace for tests
     * @namespace
     * @type {*|{}}
     */
    UX.test = UX.test || {};

    /**
     * Test browser support for input[type=date]
     * @returns {boolean}
     */
    UX.test.inputDate = function () {
        // test for input|type=date support
        // it could be better, when tests are separated and used globally - Modernizr test for this issue is much more sofisticated for example
        let hasDateInputSupport = false;

        function checkInput(type) {
            const input = document.createElement('input');
            input.setAttribute('type', type);
            return input.type === type;
        }

        function checkDateInput() {
            const input = document.createElement('input');
            input.setAttribute('type', 'date');

            const notADateValue = 'not-a-date';
            input.setAttribute('value', notADateValue);

            return input.value !== notADateValue;
        }

        if (checkInput('date') && checkDateInput()) {
            hasDateInputSupport = true;
        }

        return hasDateInputSupport;
    };

    /**
     * detect IE
     * returns version of IE or false, if browser is not Internet Explorer
     */
    UX.test.isIE = function isIE() {
        const ua = window.navigator.userAgent;
        const msie = ua.indexOf('MSIE ');
        if (msie > 0) {
            // IE 10 or older => return version number
            return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }

        const trident = ua.indexOf('Trident/');
        if (trident > 0) {
            // IE 11 => return version number
            const rv = ua.indexOf('rv:');
            return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }

        const edge = ua.indexOf('Edge/');
        if (edge > 0) {
            // Edge (IE 12+) => return version number
            return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
        }

        // other browser
        return false;
    };
})(UX);

export const isIE = UX.test.isIE();
